import { render } from "./LoginPhoneVerification.vue?vue&type=template&id=1a694712"
import script from "./LoginPhoneVerification.vue?vue&type=script&lang=js"
export * from "./LoginPhoneVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__